import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BASE_URL } from '../utils/constants';
import { ListResource } from '../utils/lazy-data-source';
import { ApiLink, ApiListWrapper, ApiRequestParams } from '../utils/types';
import { TagDetails } from './keepers-embedd-tag.resource';

export enum KeeperType {
  EMPLOYEE = 'EMPLOYEE',
  ITEM = 'ITEM',
  VEHICLE = 'VEHICLE',
}

export interface Keeper {
  _links: {
    self: ApiLink<number>;
    tag?: ApiLink<number>;
    map?: ApiLink<number>;
  };
  _embedded?: {
    tag: TagDetails,
  }
  id: number;
  name: string;
  type: KeeperType;
  labels?: string[];
  descr?: string;
  deleted?: boolean;
}

export interface Beacon {
  id?: string;
  charge_level?: number;
}

@Injectable({
  providedIn: 'root',
})
export class KeeperResource implements ListResource<Keeper> {
  constructor(private httpClient: HttpClient) {
  }

  getList(params?: ApiRequestParams): Observable<ApiListWrapper<Keeper>> {
    return this.httpClient.get<ApiListWrapper<Keeper>>(`${BASE_URL}/keepers`, { params });
  }

  get(id: number, params?: ApiRequestParams): Observable<Keeper> {
    return this.httpClient.get<Keeper>(`${BASE_URL}/keepers/${id}`, { params });
  }

  getBeacon(id: number, gap: number): Observable<Beacon> {
    return this.httpClient.get<Beacon>(`${BASE_URL}/keepers/${id}/beacon`, { params: { gap } });
  }
}
